<!--  -->
<template>
  <div>
    <div style="margin-bottom: 10px;" class="search_box">
      <el-input v-model="query.keyword" placeholder="请输入小程序名称/appid/编号" style="width:230px" />
      <el-input v-model="query.title" placeholder="请输入小程序标题" style="width:218px;" />
      <el-select v-model="query.type" placeholder="请选择小程序类型" style="width:218px">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-select v-model="query.onlyMe" placeholder="请选择">
        <el-option
          v-for="item in accountarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
    </div>

    <!-- <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="500"
    >
      <el-table-column
        prop="app_id"
        label="头像"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <img :src="scope.row.weappiconurl" alt="" srcset="" style="width:50px">
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        align="center"
        width="180"
      />
      <el-table-column
        prop="des_1"
        label="描述"
        width="180"
        align="center"
      />
      <el-table-column
        prop="pagepath"
        label="跳转路径"
        align="center"
        width="300"
      />
      <el-table-column
        prop="pagepath"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="choose(scope.row)">选择</el-button>
          <el-button type="warning" size="mini" @click="edit(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table> -->
    <div class="chooser_allbox">
      <div v-for="item,index in tableData" :key="index" class="chooser_box">
        <div class="chooser_allbox">
          <img v-if="item.weappiconurl!=''" :src="item.weappiconurl" alt="" srcset="" style="width:30px;border-radius: 50%;">
          <img v-else src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" style="width:30px;border-radius: 50%;">
          <!-- <div class="titlew_box">{{ item.title }}</div> -->
          <div class="titlew_box">{{ item.des_1 }}</div>
        </div>
        <div class="daser">{{ item.title }}</div>
        <div class="cahrw_box">
          <img :src="item.thumburl" alt="" srcset="" style="width:100%;height: 158px;">
        </div>
        <div class="line" />
        <div style="color:#252525;margin-top: 5px;">
          <span style="font-size: 15px;display: flex;align-items: center;flex-wrap: wrap;margin-bottom: 10px;">
            <el-avatar :size="20" :src="item.sender_avatar" @error="errorHandler">
              <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png">
            </el-avatar><el-tag v-if="item.sender!=''" style="margin-left: 10px;"> {{ item.sender }}</el-tag>
            <div v-else style="margin-left: 10px;width: 70px;height: 27px;" />
          </span>
          <div style="margin-bottom: 10px;">
            <el-tag style="margin-right:10px" type="warning">{{ item.type_text }}</el-tag>

            <el-tag
              v-if="item.enable == 2&&item.type==1"
              type="danger"
            >未开启</el-tag>
          </div>
          <div style="display: flex;">
            <el-tag> {{ item.created_at_str }}</el-tag>
            <el-button :disabled="item.enable!==1&&item.type==1" type="primary" size="mini" style="margin-left: 10px;" @click="choose(item)">选择</el-button>
          </div>
          <div style="font-size: 12px;margin-top: 10px;" class="copy_box">
            <el-tag v-if="item.miniprogram_no!=''" type="success">{{ item.miniprogram_no }}</el-tag>
            <div v-if="item.miniprogram_no!=''" class="copy_icon"><i
              v-clipboard:copy="item.miniprogram_no"
              v-clipboard:success="cowe"
              v-clipboard:error="onError"
              style="cursor: pointer;margin-left: 5px;"
              class="el-icon-document-copy"
            /></div>
          </div>
        </div>
      </div>
    </div>

    <pagination-right
      :current-page="query.page"
      :page-sizes="[20]"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="修改小程序"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      width="30%"
    >
      <el-form label-position="right" label-width="80px" :model="itemwechat">
        <el-form-item label="标题">
          <el-input v-model="itemwechat.title" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="itemwechat.des_1" />
        </el-form-item>
        <el-form-item label="跳转路径">
          <el-input v-model="itemwechat.pagepath" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="sumbit">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { appletlistrw } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 20,
        department: 2,
        keyword: null,
        title: null,
        type: null,
        onlyMe: 2
      },
      options: [
        {
          value: 1,
          label: '企微消息小程序'
        }, {
          value: 2,
          label: '微信客服小程序'
        }, {
          value: 3,
          label: '微信官方小程序'
        }
      ],
      accountarr: [{
        value: 1,
        label: '查看组内小程序'
      }, {
        value: 2,
        label: '我关联的小程序'
      }],
      tableData: [],
      total: null,
      itemwechat: {},
      dialogVisible: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    cowe() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onError() {
      this.$message({
        message: '复制失败',
        type: 'error'
      })
    },
    send() {
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keyword = null
      this.query.title = null
      this.query.type = null
      this.query.onlyMe = 2
      this.list()
    },
    async list() {
      const data = await appletlistrw(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data-----------', this.tableData)
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    choose(item) {
      console.log(item)
      // this.$emit('wechatcallback', item)
      this.$emit('callwechatrcr', item)
    },
    edit(item) {
      this.dialogVisible = true
      this.itemwechat = item
    },
    sumbit() {
      if (this.itemwechat.des_1 === '') {
        this.$message({
          type: 'error',
          message: `请输入描述`
        })
        return
      }
      if (this.itemwechat.title === '') {
        this.$message({
          type: 'error',
          message: `请输入标题`
        })
        return
      }
      if (this.itemwechat.pagepath === '') {
        this.$message({
          type: 'error',
          message: `请输入跳转地址`
        })
        return
      }
      this.$emit('wechatcallback', this.itemwechat)
    },
    errorHandler() {}
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.chooser_allbox{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 600px;
  overflow-y: auto;
}
.chooser_box{
  width: 250px;
  height: 420px;
  border: 1px solid #e9e9e9;
  padding: 12px;
  box-sizing: border-box;
  /* margin: 0 auto; */
  margin-right: 10px;
  margin-bottom: 20px;
}
.titlew_box{
  margin-left: 5px;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cahrw_box{
  margin-top: 10px;
}
.line{
  height: 1px;
  background-color: #e9e9e9;
  width: 100%;
  margin-top: 8px;
}
.daser{
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 222px;
  margin-top:5px;
  height: 32px;
}
.copy_box{
  display: flex;
  align-items: center;
}
</style>
